import { MessageKey } from "../message-key.js";
export const es = {
    [MessageKey.accountAlreadyConfirmed]: `Cuenta ya confirmada.`,
    [MessageKey.accountAlreadyExists]: `La cuenta ya existe y está confirmada.`,
    [MessageKey.accountConfirmed]: `Cuenta confirmada con éxito! Ahora puedes iniciar sesión.`,
    [MessageKey.accountCreated]: `Cuenta creada. Se envió un correo de confirmación.`,
    [MessageKey.accountData]: `Datos de la cuenta autenticada.`,
    [MessageKey.accountNotConfirmed]: `Por favor confirma tu cuenta para continuar.`,
    [MessageKey.accountNotFound]: `Cuenta no encontrada.`,
    [MessageKey.accountPendingConfirmation]: `La cuenta ya existe pero no está confirmada.`,
    [MessageKey.confirmationEmailSent]: `Correo de confirmación enviado.`,
    [MessageKey.confirmationTooSoon]: `Correo de confirmación enviado recientemente. Intenta más tarde.`,
    [MessageKey.confirmationTryAfterMinutes]: `La cuenta aún no está confirmada. Intenta iniciar sesión de nuevo en {minutes} minutos para recibir otro enlace de confirmación.`,
    [MessageKey.healthOk]: `Servicio en buen estado.`,
    [MessageKey.incorrectOldPassword]: `La contraseña anterior es incorrecta.`,
    [MessageKey.internalServerError]: `Error interno del servidor.`,
    [MessageKey.invalidCredentials]: `El correo o la contraseña son incorrectos.`,
    [MessageKey.invalidEmail]: `Dirección de correo inválida.`,
    [MessageKey.loginSuccessful]: `Has iniciado sesión.`,
    [MessageKey.logoutSuccessful]: `Cierre de sesión exitoso.`,
    [MessageKey.notAuthenticated]: `Debes iniciar sesión para continuar.`,
    [MessageKey.passwordChanged]: `Contraseña cambiada con éxito.`,
    [MessageKey.passwordReset]: `Contraseña restablecida con éxito.`,
    [MessageKey.resetEmailSent]: `Si la cuenta existe y está confirmada, se envió un correo de restablecimiento.`,
    [MessageKey.resetTokenInvalid]: `Token de restablecimiento inválido.`,
    [MessageKey.resetTokenMissing]: `Token de restablecimiento no encontrado. Solicita uno nuevo.`,
    [MessageKey.resetTooSoon]: `Correo de restablecimiento enviado recientemente. Intenta más tarde.`,
    [MessageKey.routeNotFound]: `Ruta no encontrada.`,
    [MessageKey.sessionInvalid]: `Tu sesión ha expirado. Por favor inicia sesión nuevamente.`,
    [MessageKey.tokenMismatch]: `El token de confirmación no coincide.`,
    [MessageKey.tokenNotFound]: `Token de confirmación no encontrado.`,
    [MessageKey.invalidTurnstileToken]: `Token de Turnstile inválido.`,
    [MessageKey.missingTurnstileToken]: `Token de Turnstile ausente.`,
    [MessageKey.turnstileVerificationFailed]: `La verificación de Turnstile falló.`,
    [MessageKey.accountPreferences]: `Preferencias del usuario.`,
    [MessageKey.accountPreferencesUpdated]: `Preferencias del usuario actualizadas.`,
    [MessageKey.accountProfileUpdated]: `Perfil de la cuenta actualizado.`,
    [MessageKey.forbiddenOrigin]: `Prohibido: origen no permitido`,
    [MessageKey.forbiddenOriginSecret]: `Prohibido: secreto de origen inválido o ausente`,
};
//# sourceMappingURL=es.js.map